"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeThemeOverride = exports.extendTheme = void 0;
const theme_1 = require("@chakra-ui/theme");
const utils_1 = require("@chakra-ui/utils");
function extendTheme(...extensions) {
    let overrides = [...extensions];
    let baseTheme = extensions[extensions.length - 1];
    if ((0, theme_1.isChakraTheme)(baseTheme) &&
        overrides.length > 1) {
        overrides = overrides.slice(0, overrides.length - 1);
    }
    else {
        baseTheme = theme_1.theme;
    }
    return (0, utils_1.pipe)(...overrides.map(extension => (prevTheme) => (0, utils_1.isFunction)(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)))(baseTheme);
}
exports.extendTheme = extendTheme;
function mergeThemeOverride(...overrides) {
    return (0, utils_1.mergeWith)({}, ...overrides, mergeThemeCustomizer);
}
exports.mergeThemeOverride = mergeThemeOverride;
function mergeThemeCustomizer(source, override, key, object) {
    if (((0, utils_1.isFunction)(source) || (0, utils_1.isFunction)(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
        return (...args) => {
            const sourceValue = (0, utils_1.isFunction)(source) ? source(...args) : source;
            const overrideValue = (0, utils_1.isFunction)(override) ? override(...args) : override;
            return (0, utils_1.mergeWith)({}, sourceValue, overrideValue, mergeThemeCustomizer);
        };
    }
    return undefined;
}
